import React from "react";
import PropTypes from 'prop-types';
import LevtyButton from "../levty-ui/levtyButton";

const Card = ({
  title,
  subtitle,
  spotlight,
  divider,
  itemsAlign,
  itemsIcon,
  items,
  button,
}) => {

  return (
    <div   translate="no" className="notranslate card">
      <div   translate="no" className="notranslate card-body">
        {!!title && <h3   translate="no" className="notranslate card-title">{title}</h3>}
        {!!spotlight &&
          <div   translate="no" className="notranslate card-spotlight">
            <p   translate="no" className="notranslate card-text mt-0 mb-1">A partir de </p>
            <span>R$</span> <h2>{spotlight.price}</h2> <span> / mês</span>
          </div>
        }
        {!!subtitle && <p   translate="no" className="notranslate card-subtitle">{subtitle}</p>}
        {divider && <div   translate="no" className="notranslate card-divider"></div>}
        {!!items && items.length > 0 &&
          <ul className="notranslate card-text">
            {items.map((item, index) => <li key={index} className={(itemsIcon ? "with-icon " : "") + "card-text-" + itemsAlign} >{item}</li>)}
          </ul>
        }
        {!!button &&
          <div   translate="no" className="notranslate card-button">
            <LevtyButton label={button.label} size="md" onClick={button.onClick} />
          </div>
        }
      </div>
    </div>
  );
}

Card.defaultProps = {
  divider: false,
  itemsAlign: "left",
  itemsIcon: true
}

Card.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  spotlight: PropTypes.shape({
    price: PropTypes.string,
    periodicity: PropTypes.string
  }),
  divider: PropTypes.bool,
  itemsAlign: PropTypes.oneOf(['left', 'center']),
  itemsIcon: PropTypes.bool,
  items: PropTypes.arrayOf(PropTypes.string),
  button: PropTypes.shape({
    label: PropTypes.string,
    onClick: PropTypes.func
  })
}

export default Card;
